import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withKeys as _withKeys, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Inloggen", -1)
const _hoisted_2 = { class: "content-box" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { class: "content-box" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]

import {ref} from "vue";
	import {useRouter} from 'vue-router';
	import {FetchToken} from "../utils/FetchData";
	import emitter from '../main';

	
export default /*#__PURE__*/_defineComponent({
  __name: 'LoginPage',
  props: {
		unauthorized: {type: Boolean, required: false, default: false}
	},
  setup(__props) {

	const props = __props;

	const email = ref('');
	const password = ref('');
	const router = useRouter();
	const loading = ref(false);

	async function login() {
		loading.value = true;

		const body = new URLSearchParams({
			email: email.value,
			password: password.value
		});

		const data = await FetchToken('login', body);
		if(!data.isError) {
			sessionStorage.setItem('token', data.access_token);
			sessionStorage.setItem('player', JSON.stringify(data.player));
			emitter.emit('authorized');

			if(!props.unauthorized && router.currentRoute.value.name == 'login')
				router.replace('/');
		}

		loading.value = false;
	}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        placeholder: "Email",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
        disabled: loading.value
      }, null, 8, _hoisted_3), [
        [_vModelText, email.value]
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _withDirectives(_createElementVNode("input", {
        type: "password",
        placeholder: "Wachtwoord",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
        disabled: loading.value,
        onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (login()), ["enter"]))
      }, null, 40, _hoisted_5), [
        [_vModelText, password.value]
      ])
    ]),
    _createElementVNode("button", {
      class: "content-box",
      onClick: login,
      disabled: loading.value
    }, " Inloggen ", 8, _hoisted_6),
    _createVNode(_component_router_link, {
      to: "/register",
      class: "login-link"
    }, {
      default: _withCtx(() => [
        _createTextVNode("Registreren")
      ]),
      _: 1
    }),
    _createVNode(_component_router_link, {
      to: "/forgot",
      class: "login-link"
    }, {
      default: _withCtx(() => [
        _createTextVNode("Wachtwoord vergeten")
      ]),
      _: 1
    })
  ], 64))
}
}

})